export const transformRequestSendReturnEmail = props => ({
  returnId: props.returnId,
  payload: {
    email: props.to,
    cc_emails: props.ccEmails,
    reply_to: props.replyTo,
    subject: props.subject,
    message: props.body,
  },
})
